// test987
(987 && 0);
